import { useState, useCallback, useMemo } from 'react';

export interface ApiKeysFilterState {
  name: string;
  activeFilters: string[];
}

interface UseApiKeysFilter {
  filterState: ApiKeysFilterState;
  handleNameFilterChange: (value: string) => void;
  clearFilters: () => void;
  removeFilter: (filter: string) => void;
}

const useApiKeysFilter = (): UseApiKeysFilter => {
  const [name, setName] = useState<string>('');

  const activeFilters = useMemo(() => {
    const filters: string[] = [];
    if (name.trim()) {
      filters.push(`Name: ${name.trim()}`);
    }
    return filters;
  }, [name]);

  const filterState: ApiKeysFilterState = useMemo(() => ({
    name,
    activeFilters
  }), [name, activeFilters]);

  const handleNameFilterChange = useCallback((value: string) => {
    setName(value);
  }, []);

  const clearFilters = useCallback(() => {
    setName('');
  }, []);

  const removeFilter = useCallback((filter: string) => {
    if (filter.startsWith('Name:')) {
      setName('');
    }
  }, []);

  return {
    filterState,
    handleNameFilterChange,
    clearFilters,
    removeFilter
  };
};

export default useApiKeysFilter;
